<div class="page-holder">
  <div class="two-columns-holder">


    <div>
      <h3>Dane rodzica</h3>
      @if (parent) {
      <form [formGroup]="parentForm">
        <div class="parent-info">
          <p><strong>Imię:</strong> {{ parent.name }}</p>
          <p><strong>Nazwisko:</strong> {{ parent.surname }}</p>
          <p><strong>Data urodzenia:</strong> {{ parent.birthday | date:'yyyy-MM-dd' }}</p>
          <div class="checkbox-container">
            <mat-checkbox formControlName="confirm_parent_status" (change)="onParentConfirmationChange()"
              class="accept-confirm_parent_status">
              Oświadczam, że nie jestem pozbawiony władzy rodzicielskiej ani ograniczony we władzy rodzicielskiej przez
              umieszczenie
              dziecka w pieczy zastępczej oraz mam na utrzymaniu wskazane powyżej dzieci wymienione we wniosku
              o przyznanie Karty ZGrane Grono.
            </mat-checkbox>
          </div>
          @if (!isParentStatusConfirmed) {
          <div class="warning-message"
            style="color: #c62828; padding: 10px; background: #ffebee; border-radius: 4px; margin-top: 10px;">
            <strong>Uwaga:</strong> Musisz zaakceptować oświadczenie, aby móc dodawać lub edytować dzieci.
          </div>
          }
        </div>
      </form>
      }
    </div>
    <div>
      @if (isParentStatusConfirmed) {

      <h3>Dodaj dziecko</h3>
      <div class="new-child-form">
        <form [formGroup]="newChildForm" (ngSubmit)="addChild()">
          <div class="fields-holder ">
            <mat-form-field appearance="outline" class="form-field">
              <mat-label>Imię</mat-label>
              <input appCamelCaseAutoFormat matInput formControlName="name" />
              @if (newChildForm.get('name')?.hasError('required')) {
              <mat-error>
                Imię jest wymagane
              </mat-error>
              }
              @if (newChildForm.get('name')?.hasError('minlength')) {
              <mat-error>
                Imię musi mieć co najmniej 2 znaki
              </mat-error>
              }
            </mat-form-field>
            <mat-form-field appearance="outline" class="form-field">
              <mat-label>Nazwisko</mat-label>
              <input appCamelCaseAutoFormat matInput formControlName="surname" />
              @if (newChildForm.get('surname')?.hasError('required')) {
              <mat-error>
                Nazwisko jest wymagane
              </mat-error>
              }
              @if (newChildForm.get('surname')?.hasError('minlength')) {
              <mat-error>
                Nazwisko musi mieć co najmniej 2 znaki
              </mat-error>
              }
            </mat-form-field>
          </div>
          <div class="fields-holder">
            <mat-form-field appearance="outline" class="form-field">
              <mat-label>Data urodzenia</mat-label>
              <input readonly (focus)="picker2.open()" matInput [matDatepicker]="picker2" [min]="minDate"
                [max]="maxDate" formControlName="birthday" />
              <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
              <mat-datepicker #picker2 startView="multi-year"></mat-datepicker>
              @if (newChildForm.get('birthday')?.hasError('required')) {
              <mat-error>
                Data urodzenia jest wymagana
              </mat-error>
              }
              @if (newChildForm.get('birthday')?.hasError('matDatepickerParse')) {
              <mat-error>
                Nieprawidłowy format daty
              </mat-error>
              }
              @if (newChildForm.get('birthday')?.hasError('matDatepickerMin')) {
              <mat-error>
                Data urodzenia nie może być starsza niż 120 lat
              </mat-error>
              }
              @if (newChildForm.get('birthday')?.hasError('matDatepickerMax')) {
              <mat-error>
                Data urodzenia nie może być z przyszłości
              </mat-error>
              }
            </mat-form-field>
            <!--
            <div class="form-debug" *ngIf="newChildForm.invalid" style="margin: 10px 0; padding: 10px; background: #ffebee; border-radius: 4px;">
              <h4 style="margin: 0 0 5px 0; color: #c62828;">Błędy formularza:</h4>
              <ul style="margin: 0; padding-left: 20px; color: #c62828;">
                <li *ngIf="newChildForm.get('name')?.invalid">
                  Imię: {{ newChildForm.get('name')?.errors | json }}
                </li>
                <li *ngIf="newChildForm.get('surname')?.invalid">
                  Nazwisko: {{ newChildForm.get('surname')?.errors | json }}
                </li>
                <li *ngIf="newChildForm.get('birthday')?.invalid">
                  Data urodzenia: {{ newChildForm.get('birthday')?.errors | json }}
                </li>
              </ul>
            </div>
            -->
            <button class="custom-button" mat-raised-button color="primary" type="submit"
              [disabled]="newChildForm.invalid || !isParentStatusConfirmed">
              Dodaj
            </button>
          </div>
        </form>
      </div>

      }
    </div>
  </div>


  <div class="children-list">
    <h3>Twoje dzieci</h3>
    @if (loading) {
    <div>Ładowanie...</div>
    }
    @if (isParentStatusConfirmed && children.length > 0) {
    <div class="children-tiles">
      @for (child of children; track child) {
      <div class="child-tile">
        <!-- Display Mode -->
        @if (editingChildId !== child.id && isParentStatusConfirmed) {
        <div class="child-actions">
          <button mat-icon-button color="primary" class="edit-btn" (click)="editChild(child)" title="Edytuj dziecko"
            [disabled]="!isParentStatusConfirmed">
            <mat-icon>edit</mat-icon>
          </button>
          <button mat-icon-button color="warn" class="delete-btn" (click)="deleteChild(child.id)" title="Usuń dziecko"
            [disabled]="!isParentStatusConfirmed">
            <mat-icon>delete</mat-icon>
          </button>
        </div>
        <div class="child-display">
          <div class="child-data">
            <div class="child-name">{{ child.name }} {{ child.surname }}</div>
            <div class="child-birthday">Data urodzenia: {{ child.birthday | date:'yyyy-MM-dd' }}</div>
          </div>

        </div>

        @if (!isChildAccountFormDisabled(child)) {

        @if (!hasChildUserAccount(child)) { <div class="child-account-box">
          <div class="child-account-header">Konto dziecka</div>
          <p class="child-account-description">
            Utwórz konto dla swojego dziecka pozwalajace na używanie aplikacji przez dziecko od 13 do 18 roku zycia.
          </p>

          @if (isChildAccountFormDisabled(child)) {
          <div class="child-account-disabled-info">
            Formularz jest nieaktywny dla tego dziecka ze względu na wiek.
          </div>
          }

          <form class="child-account-form" [formGroup]="getChildAccountForm(child.id)"
            (ngSubmit)="createChildUserAccount(child)">
            <mat-form-field appearance="outline" class="form-field">
              <mat-label>Email dziecka</mat-label>
              <input matInput type="email" formControlName="email" [disabled]="isChildAccountFormDisabled(child)" />
              @if (getChildAccountForm(child.id).get('email')?.hasError('required')) {
              <mat-error>Email jest wymagany</mat-error>
              }
              @if (getChildAccountForm(child.id).get('email')?.hasError('email')) {
              <mat-error>Podaj poprawny adres email</mat-error>
              }
            </mat-form-field>

            <div class="fields-holder child-account-password-row">
              <mat-form-field appearance="outline" class="form-field">
                <mat-label>Hasło</mat-label>
                <input matInput type="password" formControlName="password"
                  [disabled]="isChildAccountFormDisabled(child)" />
                @if (getChildAccountForm(child.id).get('password')?.hasError('required')) {
                <mat-error>Hasło jest wymagane</mat-error>
                }
                @if (getChildAccountForm(child.id).get('password')?.hasError('minlength')) {
                <mat-error>Hasło musi mieć co najmniej 8 znaków</mat-error>
                }
              </mat-form-field>

              <mat-form-field appearance="outline" class="form-field">
                <mat-label>Powtórz hasło</mat-label>
                <input matInput type="password" formControlName="rePassword"
                  [disabled]="isChildAccountFormDisabled(child)" />
                @if (getChildAccountForm(child.id).get('rePassword')?.hasError('required')) {
                <mat-error>Powtórzenie hasła jest wymagane</mat-error>
                }
                @if (getChildAccountForm(child.id).hasError('passwordMismatch') &&
                getChildAccountForm(child.id).get('rePassword')?.touched) {
                <mat-error>Hasła muszą być takie same</mat-error>
                }
              </mat-form-field>
            </div>

            <button class="custom-button" mat-raised-button color="accent" type="submit"
              [disabled]="getChildAccountForm(child.id).invalid || childAccountLoading[child.id] || isChildAccountFormDisabled(child)">
              {{ childAccountLoading[child.id] ? 'Tworzenie konta...' : 'Utwórz konto dziecka' }}
            </button>
          </form>
      </div>
      } @else {
      <div class="child-account-info">
        <p>Konto dziecka zostało utworzone. Dziecko może teraz korzystać z aplikacji.
        </p>
        <p>
          Adres email dziecka: <strong>{{ child.user_email }}</strong>
          <button class="custom-button" type="button" (click)="startChildEmailEdit(child)">
            Zmień email
          </button>
        </p>

        @if (childEmailEditMode[child.id]) {
        <form class="child-account-form" [formGroup]="getChildEmailChangeForm(child.id)"
          (ngSubmit)="submitChildEmailChange(child)">
          <mat-form-field appearance="outline" class="form-field">
            <mat-label>Nowy email dziecka</mat-label>
            <input matInput type="email" formControlName="email" />
            @if (getChildEmailChangeForm(child.id).get('email')?.hasError('required')) {
            <mat-error>Email jest wymagany</mat-error>
            }
            @if (getChildEmailChangeForm(child.id).get('email')?.hasError('email')) {
            <mat-error>Podaj poprawny adres email</mat-error>
            }
          </mat-form-field>
          <div class="child-email-actions">
            <button class="custom-button" mat-raised-button color="accent" type="submit"
              [disabled]="getChildEmailChangeForm(child.id).invalid || childAccountLoading[child.id]">
              {{ childAccountLoading[child.id] ? 'Zmiana...' : 'Zmień' }}
            </button>
            <button class="custom-button" type="button" (click)="cancelChildEmailEdit(child.id)">
              Anuluj
            </button>
          </div>
        </form>
        }
      </div>
      }
    }
  }
      <!-- Edit Mode -->
      @if (editingChildId === child.id && isParentStatusConfirmed) {
      <div class="child-edit">
        <form [formGroup]="childForm" (ngSubmit)="updateChild()" class="inline-edit-form">
          <div class="fields-holder">
            <mat-form-field appearance="outline" class="form-field">
              <mat-label>Imię</mat-label>
              <input appCamelCaseAutoFormat matInput formControlName="name" />
            </mat-form-field>
          </div>
          <div class="fields-holder">
            <mat-form-field appearance="outline" class="form-field">
              <mat-label>Nazwisko</mat-label>
              <input appCamelCaseAutoFormat matInput formControlName="surname" />
            </mat-form-field>
          </div>
          <div class="fields-holder">
            <mat-form-field appearance="outline" class="form-field">
              <mat-label>Data urodzenia</mat-label>
              <input readonly (focus)="picker.open()" matInput [matDatepicker]="picker" [min]="minDate" [max]="maxDate"
                formControlName="birthday" />
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker startView="multi-year"></mat-datepicker>
              @if (childForm.get('birthday')?.hasError('required')) {
              <mat-error>
                Data urodzenia jest wymagana
              </mat-error>
              }
              @if (childForm.get('birthday')?.hasError('matDatepickerParse')) {
              <mat-error>
                Nieprawidłowy format daty
              </mat-error>
              }
              @if (childForm.get('birthday')?.hasError('matDatepickerMin')) {
              <mat-error>
                Data urodzenia nie może być starsza niż 120 lat
              </mat-error>
              }
              @if (childForm.get('birthday')?.hasError('matDatepickerMax')) {
              <mat-error>
                Data urodzenia nie może być z przyszłości
              </mat-error>
              }
            </mat-form-field>
          </div>
          <div class="fields-holder">
            <div class="edit-actions">
              <button class="custom-button" type="submit" [disabled]="childForm.invalid" title="Zapisz">
                <mat-icon>check</mat-icon>
              </button>
              <button class="custom-button" type="button" (click)="cancelEdit()" title="Anuluj">
                <mat-icon>close</mat-icon>
              </button>
            </div>
          </div>
        </form>
      </div>
      }
    </div>
    }
  </div>
  }

  @if (!loading && children.length === 0) {
  <div>Brak dzieci.</div>
  }
</div>


</div>